import { fromJS } from 'immutable';
import * as constants from './constants';

//初始化数据
const defaultState = fromJS({

    patchList: [],  // 采集点列表

    patchDetailData: {},  // 采集点 详情

    patchDeviceList: {content: []},  //根据采集点查询采集点下的设备 -- 显示列表

    unPatchDeviceList: {content: []},  //根据采集点查询采集点下的设备 -- 末添加到采集点的设备列表

    deviceTypeList: [],  //根据采集点查询采集点下的设备 -- 设备类型搜索下拉

    childDeviceList: {content: []},  //根据采集点查询采集点下的设备 -- 查询子设备列表数据

    childPatchList: {content: []},  //根据采集点查询子采集点列表数据

    productList:[]
});

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = defaultState, action) => {
    switch (action.type) {
        //采集点列表
        case constants.PATCH_DATA_LIST:
            return state.set('patchList', action.data);

        //采集点 详情
        case constants.PATCH_DATA_DETAIL:
            return state.set('patchDetailData', action.data);

        //根据采集点查询采集点下的设备
        case constants.PATCH_DEVICE_LIST:
            return state.set('patchDeviceList', action.data);

        //根据采集点查询采集点下的设备 -- 设备类型搜索下拉
        case constants.DEVICE_TYPE_LIST:
            return state.set('deviceTypeList', action.data);

        //根据采集点查询采集点下的设备 -- 查询子设备列表数据
        case constants.CHILD_DEVICE_DATA_LIST:
            return state.set('childDeviceList', action.data);

        //查询末添加到采集点的设备
        case constants.UN_PATCH_DEVICE_DATA_LIST:
            return state.set('unPatchDeviceList', action.data);

        //根据采集点查询子采集点列表数据
        case constants.CHILD_PATCH_DATA_LIST:
            return state.set('childPatchList', action.data);

        case constants.productList:
            return state.set('productList', action.data);
        default:
            return state;
    }
};
